// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_automation_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { DemandAutoConfirmMethod, WorkflowSection } from "./workflow_template_model_pb";
import { file_bffuser_v1_workflow_template_model } from "./workflow_template_model_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/workflow_automation_service.proto.
 */
export const file_bffuser_v1_workflow_automation_service: GenFile = /*@__PURE__*/
  fileDesc("CixiZmZ1c2VyL3YxL3dvcmtmbG93X2F1dG9tYXRpb25fc2VydmljZS5wcm90bxIKYmZmdXNlci52MSIqCihHZXRXb3JrZmxvd0F1dG9tYXRpb25BdmFpbGFiaWxpdHlSZXF1ZXN0IqMBCilHZXRXb3JrZmxvd0F1dG9tYXRpb25BdmFpbGFiaWxpdHlSZXNwb25zZRIXCg9mZWF0dXJlX2VuYWJsZWQYASABKAgSXQoiZGVtYW5kX2F1dG9fY29uZmlybV9tZXRob2Rfb3B0aW9ucxgCIAMoCzIxLmJmZnVzZXIudjEuRGVtYW5kQXV0b0NvbmZpcm1TZWN0aW9uTWV0aG9kT3B0aW9ucyLTAQolRGVtYW5kQXV0b0NvbmZpcm1TZWN0aW9uTWV0aG9kT3B0aW9ucxIsCgdzZWN0aW9uGAEgASgOMhsuYmZmdXNlci52MS5Xb3JrZmxvd1NlY3Rpb24SOgoHbWV0aG9kcxgCIAMoCzIpLmJmZnVzZXIudjEuRGVtYW5kQXV0b0NvbmZpcm1NZXRob2RPcHRpb24SQAoNb3RoZXJfbWV0aG9kcxgDIAMoCzIpLmJmZnVzZXIudjEuRGVtYW5kQXV0b0NvbmZpcm1NZXRob2RPcHRpb24iaAodRGVtYW5kQXV0b0NvbmZpcm1NZXRob2RPcHRpb24SMwoGbWV0aG9kGAEgASgOMiMuYmZmdXNlci52MS5EZW1hbmRBdXRvQ29uZmlybU1ldGhvZBISCgpzZWxlY3RhYmxlGAIgASgIMrABChlXb3JrZmxvd0F1dG9tYXRpb25TZXJ2aWNlEpIBCiFHZXRXb3JrZmxvd0F1dG9tYXRpb25BdmFpbGFiaWxpdHkSNC5iZmZ1c2VyLnYxLkdldFdvcmtmbG93QXV0b21hdGlvbkF2YWlsYWJpbGl0eVJlcXVlc3QaNS5iZmZ1c2VyLnYxLkdldFdvcmtmbG93QXV0b21hdGlvbkF2YWlsYWJpbGl0eVJlc3BvbnNlIgBCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bffuser_v1_workflow_template_model]);

/**
 * @generated from message bffuser.v1.GetWorkflowAutomationAvailabilityRequest
 */
export type GetWorkflowAutomationAvailabilityRequest = Message<"bffuser.v1.GetWorkflowAutomationAvailabilityRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetWorkflowAutomationAvailabilityRequest.
 * Use `create(GetWorkflowAutomationAvailabilityRequestSchema)` to create a new message.
 */
export const GetWorkflowAutomationAvailabilityRequestSchema: GenMessage<GetWorkflowAutomationAvailabilityRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_automation_service, 0);

/**
 * @generated from message bffuser.v1.GetWorkflowAutomationAvailabilityResponse
 */
export type GetWorkflowAutomationAvailabilityResponse = Message<"bffuser.v1.GetWorkflowAutomationAvailabilityResponse"> & {
  /**
   * @generated from field: bool feature_enabled = 1;
   */
  featureEnabled: boolean;

  /**
   * @generated from field: repeated bffuser.v1.DemandAutoConfirmSectionMethodOptions demand_auto_confirm_method_options = 2;
   */
  demandAutoConfirmMethodOptions: DemandAutoConfirmSectionMethodOptions[];
};

/**
 * Describes the message bffuser.v1.GetWorkflowAutomationAvailabilityResponse.
 * Use `create(GetWorkflowAutomationAvailabilityResponseSchema)` to create a new message.
 */
export const GetWorkflowAutomationAvailabilityResponseSchema: GenMessage<GetWorkflowAutomationAvailabilityResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_automation_service, 1);

/**
 * @generated from message bffuser.v1.DemandAutoConfirmSectionMethodOptions
 */
export type DemandAutoConfirmSectionMethodOptions = Message<"bffuser.v1.DemandAutoConfirmSectionMethodOptions"> & {
  /**
   * @generated from field: bffuser.v1.WorkflowSection section = 1;
   */
  section: WorkflowSection;

  /**
   * @generated from field: repeated bffuser.v1.DemandAutoConfirmMethodOption methods = 2;
   */
  methods: DemandAutoConfirmMethodOption[];

  /**
   * @generated from field: repeated bffuser.v1.DemandAutoConfirmMethodOption other_methods = 3;
   */
  otherMethods: DemandAutoConfirmMethodOption[];
};

/**
 * Describes the message bffuser.v1.DemandAutoConfirmSectionMethodOptions.
 * Use `create(DemandAutoConfirmSectionMethodOptionsSchema)` to create a new message.
 */
export const DemandAutoConfirmSectionMethodOptionsSchema: GenMessage<DemandAutoConfirmSectionMethodOptions> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_automation_service, 2);

/**
 * @generated from message bffuser.v1.DemandAutoConfirmMethodOption
 */
export type DemandAutoConfirmMethodOption = Message<"bffuser.v1.DemandAutoConfirmMethodOption"> & {
  /**
   * @generated from field: bffuser.v1.DemandAutoConfirmMethod method = 1;
   */
  method: DemandAutoConfirmMethod;

  /**
   * @generated from field: bool selectable = 2;
   */
  selectable: boolean;
};

/**
 * Describes the message bffuser.v1.DemandAutoConfirmMethodOption.
 * Use `create(DemandAutoConfirmMethodOptionSchema)` to create a new message.
 */
export const DemandAutoConfirmMethodOptionSchema: GenMessage<DemandAutoConfirmMethodOption> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_workflow_automation_service, 3);

/**
 * WorkflowAutomationService exposes the global workflow-automation release
 * decision to authenticated browser sessions.
 *
 * @generated from service bffuser.v1.WorkflowAutomationService
 */
export const WorkflowAutomationService: GenService<{
  /**
   * @generated from rpc bffuser.v1.WorkflowAutomationService.GetWorkflowAutomationAvailability
   */
  getWorkflowAutomationAvailability: {
    methodKind: "unary";
    input: typeof GetWorkflowAutomationAvailabilityRequestSchema;
    output: typeof GetWorkflowAutomationAvailabilityResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_workflow_automation_service, 0);

